import request from '@/utils/request';
// 查询有权限店铺列表
export function getAuthShopListApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/buildPackage/productConfig/getShopList',
    method: 'post',
    data
  });
}
// 获取待揽收列表
export function getBuildPackageHarves(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillinfoQuery/harves',
    method: 'post',
    data
  });
}
// 删除列表
export function cancelWaybillHasvesApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillinfoCancel/cancelWaybillHasves',
    method: 'post',
    data
  });
}
// 获取回收站列表
export function getRecycleBinList(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillinfoQuery/recycleBinList',
    method: 'post',
    data
  });
}
// 恢复回收站列表
export function backUpCancelWaybill(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillinfoCancel/backUpCancelWaybill',
    method: 'post',
    data
  });
}
// 运单揽收列表
export function getPackageList(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillinfoQuery/packageList',
    method: 'post',
    data
  });
}
// 标记为散件
export function partsMarkWaybillApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillinfoCancel/partsMarkWaybill',
    method: 'post',
    data
  });
}
// 取消散件标记
export function cancelPartsMarkWaybillApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillinfoCancel/cancelPartsMarkWaybill',
    method: 'post',
    data
  });
}
// 取消散件标记
export function getPartsWaybillLists(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillinfoQuery/partsWaybillLists',
    method: 'post',
    data
  });
}
// 散件打印
export function getPrintWayBillInfo(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/print/printWayBillInfo',
    method: 'post',
    data
  });
}
// 上车列表查询
export function queryPickList(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillPackageQuery/queryPick',
    method: 'post',
    data
  });
}
// 建包打印列表查询
export function createPackageList(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillPackageQuery/query',
    method: 'post',
    data
  });
}
// 建包打印--整包打印
export function printPackageWaybillInfo(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/print/printPackageWaybillInfo',
    method: 'post',
    data
  });
}
// 建包打印--上车打印详情
export function waybillByPackageNo(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillinfoQuery/waybillByPackageNo',
    method: 'post',
    data
  });
}
// 只打印运单
export function printPackageOfWayBillInfo(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/print/printPackageOfWayBillInfo',
    method: 'post',
    data
  });
}
// 只打印包签
export function printPackageInfo(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/print/printPackageInfo',
    method: 'post',
    data
  });
}
// 更新三段码
export function getShortAddrApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/waybill/shortAddr',
    method: 'post',
    data
  });
}
// 揽收
export function getTakingApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/waybill/taking',
    method: 'post',
    data
  });
}
// 更新商品重量
export function updatePackageProductWeightApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/waybill/productWeight',
    method: 'post',
    data
  });
}
// 自动建包接口
export function automaticCreatPackageApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillOperate/automatic',
    method: 'post',
    data
  });
}
// 手动建包接口
export function manualCreatPackageApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillOperate/manual',
    method: 'post',
    data
  });
}
// 建包进度查询
export function creatPackageProgressApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillOperate/progress',
    method: 'post',
    data
  });
}
// 散件上车
export function partsCarApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillOperate/partsCar',
    method: 'post',
    data
  });
}
// 包上车
export function packageCarApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/wayBillOperate/packageCar',
    method: 'post',
    data
  });
}
// 商品列表查询
export function getPackageProductListApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/buildPackage/productConfig/getProductList',
    method: 'post',
    data
  });
}

